import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import ICredDefenseSmsHistory from "../interface/prefraud/cred-defense/ICredDefenseSmsHistory";

enum CredDefenseServiceEnum {
  getSmsHistory = "/get-sms-history/"
}
export default class CredDefenseService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/cred-defense");
  }
  public getSmsHistory = async (credDefenseId: number): Promise<ICredDefenseSmsHistory[]> => await this.GET(`${CredDefenseServiceEnum.getSmsHistory}${credDefenseId}`);
}



// WEBPACK FOOTER //
// ./src/services/api/CredDefense.service.ts